import React from 'react'
import { Typography } from '@mui/material'
import { Controller, type Control, type FieldErrors } from 'react-hook-form'
import { BuildingOffice2Icon } from '@heroicons/react/24/outline'

import { Input } from '../../../../interaxDesignSystemComponents'
import { INTERAX_COLORS } from '../../../../constants/colors'
import { useTranslation } from '../../../../shared/hooks/useIntractionTranslate'
import type { OnboardingFormValues } from '../types'
import { OnboardingStepCard } from '../components/OnboardingStepCard'
import { onboardingFieldLabelSx } from './stepStyles'

interface OrgIdentityStepProps {
  control: Control<OnboardingFormValues>
  errors: FieldErrors<OnboardingFormValues>
}

export const OrgIdentityStep: React.FC<OrgIdentityStepProps> = ({ control, errors }) => {
  const { t } = useTranslation()

  return (
    <OnboardingStepCard
      icon={<BuildingOffice2Icon style={{ width: 20, height: 20, color: INTERAX_COLORS.sun }} />}
      title={t('org.onboarding.stepIdentityTitle')}
      hint={t('org.onboarding.stepIdentityHint')}
    >
      <Typography sx={onboardingFieldLabelSx}>{t('org.onboarding.nameLabel')}</Typography>
      <Controller
        name="name"
        control={control}
        render={({ field }) => (
          <Input
            value={field.value}
            onChange={field.onChange}
            placeholder={t('org.onboarding.namePlaceholder')}
            fullWidth
            required
            autoFocus
            error={Boolean(errors.name)}
            errorMessage={errors.name?.message}
            data-testid="org-onboarding-name"
          />
        )}
      />
    </OnboardingStepCard>
  )
}
